import PropTypes from 'prop-types';
import CssClassMixin from '../../mixins/css_class_mixin.jsx';

var createClass = require('create-react-class');

window.ModalFooter = createClass({
  mixins: [CssClassMixin],

  propTypes: {
    separatorThemeClassKey: PropTypes.string,
    withSeparator: PropTypes.bool
  },

  getDefaultProps: function() {
    return {
      themeClassKey: 'modal.footer',
      separatorThemeClassKey: 'modal.footer.withSeparator',
      withSeparator: true
    };
  },

  render: function() {
    return <div className={this.footerClassName()}>{this.props.children}</div>;
  },

  footerClassName: function() {
    var className = this.className();
    if(this.props.withSeparator) {
      className += " " + Realize.themes.getCssClass(this.props.separatorThemeClassKey);
    }

    return className;
  }
});